import { render } from "./roles.vue?vue&type=template&id=5314819c"
const script = {}

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__